/**
 * Created by zad on 17/11/23.
 */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import { is, fromJS } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Doyle from '@jianshu/doyle';

import Arthur from '../../assets/vendors/Arthur-v1.0.0';
import ImageUploader from '../../assets/vendors/ImageUploader';

import Modal from '../../components/Modal';
import Message from '../../components/Message';
import EditorTitle from './EditorTitle';
import EditorToolBar from '../../components/EditorToolBar/EditorToolBar';
import { EditorImgModal, EditorAudioModal, EditorFilmModal, getFilmScoreText } from '../../components/EditorModal';
import TimePublishToolbar from '../TimePublishToolbar/TimePublishToolbar';

import styles from './MarkDownEditor.scss';

import { Notes } from '../../constants/actionTypes';
import { JIANSHU_EDITOR, REG_IS_QINIU } from '../../constants/variables';

import { keyDownResult, calcAbbr, getChildrenNum, captureException, martinDispatch } from '../../utils/util';
import { getPNSettingPageUrl } from '../../utils/urlHelper';

import { getState as getUserState } from '../../reducers/User/UserReducer';
import { getAudioUrl, updateNoteContentAbbr } from '../../actions/NoteContentAction';
import { privateNote, publishNote, updateNote } from '../../actions/NotesAction';

const curProtocol = window.location.protocol || '';
const doyle = new Doyle();
@withRouter
@connect(
  state => ({
    userInfos: getUserState(state).get('user'),
  }),
  dispatch => ({
    publishNote: (noteId, forcedPublish) => dispatch(publishNote(noteId, forcedPublish)),
    privateNote: noteId => dispatch(privateNote(noteId)),
    updateNote: (noteId, title, content) => {
      return martinDispatch(dispatch, updateNote(noteId, title, content));
    },
    updateNoteContentAbbr: (noteId, abbr, wordNum) => {
      dispatch(updateNoteContentAbbr(noteId, abbr, wordNum));
    },
    getAudioUrl: noteId => dispatch(getAudioUrl(noteId)),
  }),
)
export default class MarkDownEditor extends Component {
  static propTypes = {
    isWritingMode: PropTypes.bool, // 当前所在是否为全屏模式
    isPreviewMode: PropTypes.bool, // 当前所在是否为预览模式
    wrapperClassName: PropTypes.string,
  };

  static defaultProps = {
    isWritingMode: false,
    isPreviewMode: false,
  };

  state = {
    imgModalVisible: false,
    filmModalVisible: false,
    isAudioExist: this.props.content.getIn(['entities', this.props.match.params.noteId, 'audio', 'title']) !== undefined,
    isAudioPlaying: false,
    grammarModalVisible: false,
  };

  componentDidMount() {
    const { match } = this.props;
    const { params: { noteId } } = match;
    this.editor = new Arthur(document.getElementById('arthur-editor'), {
      autoResize: false,
      fileSize: 10 * 1024 * 1024, // 10MB
    });
    this.initEditorWithTryCatch(noteId);
    window[JIANSHU_EDITOR] = this;
  }

  componentWillReceiveProps(nextProps) {
    const { match, content } = nextProps;
    const { params: { noteId } } = match;
    const noteContentStatus = content.getIn(['entities', noteId, 'status']);
    const audioStatus = content.getIn(['entities', noteId, 'audio', 'title']) !== undefined;
    if (this.polling) {
      clearTimeout(this.polling);
    }
    this.setState({
      isAudioExist: audioStatus,
    });
    if (this.props.match.params.noteId !== noteId) {
      this.setState({
        isAudioPlaying: false,
      });
      try {
        this.setContent(noteId);
      } catch (error) {
        captureException(error, {
          noteId,
          hh: 'md setContent error',
        });
      }
    }
    if (content.getIn(['entities', noteId, 'audio', 'title']) !== '' && content.getIn(['entities', noteId, 'audio', 'play_url']) === '') {
      this.polling = setTimeout(() => {
        this.props.getAudioUrl(noteId);
      }, 10000);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      is(nextProps.notebooks, this.props.notebooks) &&
      is(nextProps.notes, this.props.notes) &&
      is(nextProps.content, this.props.content) &&
      is(fromJS(nextProps.match), fromJS(this.props.match)) &&
      is(fromJS(nextState), fromJS(this.state))
    );
  }

  componentWillUnmount() {
    this.editor.destroy();
    if (this.polling) {
      clearTimeout(this.polling);
    }
    window[JIANSHU_EDITOR] = null;
  }

  contentIsDiff = () => {
    const note = this.getNote();
    if (note.get('shared')) {
      return note.get('content_updated_at') > note.get('last_compiled_at');
    }
    return false;
  };

  getNote = () => {
    const { notes, match } = this.props;
    const { params: { noteId } } = match;
    return notes.getIn(['entities', noteId]);
  };

  getNoteContent = (noteId) => {
    const { content } = this.props;
    return content.getIn(['entities', noteId.toString(), 'content'], '');
  };

  getContentStatus = () => {
    const { match, content } = this.props;
    const { params: { noteId } } = match;
    return content.getIn(['entities', noteId, 'status']);
  };

  getNoteWordNum = () => {
    const { content, match } = this.props;
    const { params: { noteId } } = match;
    return content.getIn(['entities', noteId, 'wordNum'], 0);
  };

  getNoteTitle = (noteId) => {
    const { notes } = this.props;
    return notes.getIn(['entities', noteId, 'title'], '');
  };

  getEditorContent = () => {
    return this.editor.getContent();
  };

  getEditorTitle = () => {
    return this.editorTitle;
  };

  setContent = (noteId) => {
    const content = this.getNoteContent(noteId);
    this.editor.setContent(content);
  };

  alertUploadError = () => {
    Modal.Alert((
      <span>
        {i18n.get('error.upload-fail')}
        <a
          href="https://www.jianshu.com/p/acb660ddc619"
          target="_blank"
          rel="noopener noreferrer"
        >
          {i18n.get('error.click')}
        </a>
        。
      </span>
    ));
  };

  dragEnter = (e) => {
    e.target.classList.add(styles['dragging']);
  };

  dragLeave = (e) => {
    e.target.classList.remove(styles['dragging']);
  };

  editorDrop = (e) => {
    e.target.classList.remove(styles['dragging']);
  };

  onTitleChanged = ({ title, noteId }, isFirst) => {
    this.editorTitle = title;
    if (!isFirst) {
      this.saveTitle({ noteId });
    }
  };

  onContentChange = (oldVal, newVal) => {
    // 只有在图片上传后，才触发action
    if (!this.editor.isUploading()) {
      this.saveNote({});
    }
  };

  notify = (errCode) => {
    Message.setOptions({
      duration: 3000,
    });
    switch (errCode) {
      case Arthur.Errors.FILE_NOT_EXIST: {
        Message.error(i18n.get('error.file-not-exit'));
        break;
      }
      case Arthur.Errors.FILE_TOO_LARGE: {
        Message.error(i18n.get('error.file-size-over', {
          size: (this.editor.options.fileSize / 1024 / 1024).toFixed(2),
        }));
        break;
      }
      case Arthur.Errors.FILE_TYPE_ERROR: {
        Message.error(i18n.get('error.file-type-error'));
        break;
      }
      default: {
        break;
      }
    }
    Message.resetOptions();
  };

  uploadImage = (imgData, successFn, failFn) => {
    // 真正需要上传的图片
    const needUploadImages = imgData.filter((img) => {
      return img.file || !REG_IS_QINIU.test(img.url);
    });
    // 已经上传过的图片，可以直接set到文章内
    const qiniuImages = imgData.filter(img => REG_IS_QINIU.test(img.url)).map(({ id, ...data }) => {
      return {
        id,
        data,
      };
    });
    // 直接调用上传成功的callback
    qiniuImages.forEach((img) => {
      successFn(img);
    });
    // 真正进行上传
    if (needUploadImages.length > 0) {
      let uploadError = false;
      const uploader = new ImageUploader(needUploadImages, {
        size: 10 * 1024 * 1024, // 10MB
        'x:protocol': curProtocol.slice(0, -1),
      });
      needUploadImages.forEach(async (img) => {
        try {
          const data = await uploader.upload(img);
          successFn({
            id: img.id,
            data,
          });
          if (uploader.isCompleted()) {
            if (uploadError) {
              this.alertUploadError();
            }
          }
        } catch (err) {
          uploadError = true;
          failFn({
            id: img.id,
            err,
          });
          if (uploader.isCompleted()) {
            this.alertUploadError();
          }
        }
      });
    }
  };

  uploadExternalImage = (imgData, successFn, failFn) => {
    let uploadError = false;
    const uploader = new ImageUploader(imgData, {
      size: 10 * 1024 * 1024, // 10MB
      'x:protocol': curProtocol.slice(0, -1),
    });

    imgData.forEach(async (img) => {
      try {
        const data = await uploader.upload(img);
        successFn({
          id: img.id,
          data,
        });
        if (uploader.isCompleted()) {
          if (uploadError) {
            this.alertUploadError();
          } else {
            this.saveNote({
              autoPublish: true,
            });
          }
        }
      } catch (err) {
        uploadError = true;
        failFn({
          id: img.id,
          err,
        });
        if (uploader.isCompleted()) {
          this.alertUploadError();
        }
      }
    });
  };

  updateAbbr = () => {
    const { match } = this.props;
    const { params: { noteId } } = match;
    // 更新abbr和字数
    const { abbr, wordNum } = calcAbbr(this.editor.getContent(), true);
    this.props.updateNoteContentAbbr(noteId, abbr, wordNum);
  };

  saveTitle({ noteId }) {
    const title = this.getEditorTitle();
    const noteTitle = this.getNoteTitle(noteId);
    if (title !== noteTitle) {
      const noteContent = this.getNoteContent(noteId);
      this.props.updateNote(noteId, title, noteContent).then(() => {
        this.updateAbbr();
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  saveNote = ({ autoPublish = false, isForce = false }) => {
    const { match: { params: { noteId } } } = this.props;
    const content = this.getEditorContent();
    const noteContent = this.getNoteContent(noteId);
    const isChanged = content !== noteContent;
    if (isChanged || isForce) {
      const noteTitle = this.getNoteTitle(noteId);
      this.props.updateNote(noteId, noteTitle, content).then(() => {
        this.updateAbbr();
        if (autoPublish) {
          this.props.publishNote(noteId);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  };

  changeAudio = () => {
    const { match: { params: { noteId } } } = this.props;
    this.saveNote({ isForce: true });
  }

  onKeyDown = (e) => {
    const result = keyDownResult(e);
    if (result.save) {
      this.saveNote({
        isForce: true,
      });
      e.preventDefault();
    }
  };

  openImgModal = () => {
    this.setState({
      imgModalVisible: true,
    });
  };

  closeImgModal = () => {
    this.setState({
      imgModalVisible: false,
    });
  };

  publicizePaidNote = (nbId, noteId, isCompile) => {
    const { history, userInfo } = this.props;
    const content = doyle.parse(this.getNoteContent(noteId));
    if (getChildrenNum(content) < 2) {
      Message.error(i18n.get('error.content-not-enough', { num: 2 }));
      return;
    }
    if (isCompile) {
      JsSensor.trackEvent(SAEVENTS.COMPILE_PAID_NOTE_BTN_CLICK);
    } else {
      JsSensor.trackEvent(SAEVENTS.PUBLISH_PAID_NOTE_BTN_CLICK);
    }
    history.push(getPNSettingPageUrl(nbId, noteId));
  }

  publicNote = (noteId, { isCompile, forcedPublish }) => {
    const { content } = this.props;
    const playUrl = content.getIn(['entities', noteId.toString(), 'audio', 'play_url']);
    if (playUrl === '') {
      Modal.Alert(i18n.get('modal.audio-transcoding'));
      return;
    }
    if (this.editor.isUploading()) {
      return;
    }
    const externalImages = this.editor.checkExternalImages();
    if (externalImages.length === 0) {
      this.props.publishNote(noteId, forcedPublish);
    }
    // 更新文章
    if (isCompile) {
      JsSensor.trackEvent(SAEVENTS.COMPILE_NOTE_BTN_CLICK);
    } else {
      JsSensor.trackEvent(SAEVENTS.PUBLISH_NOTE_BTN_CLICK);
    }
  };

  publicizeNote = (noteId, isCompile) => {
    const note = this.getNote();
    const isSetTimePublish = !!note.get('schedule_publish_at');
    if (isSetTimePublish) {
      Modal.Confirm('该文章已设置成定时发布，确定现在就要发布么？', {
        onOk: () => {
          this.publicNote(noteId, { isCompile, forcedPublish: true });
        },
      });
    } else {
      this.publicNote(noteId, { isCompile });
    }
  };

  onImgModalOk = (modalName, { files: items }, isFile) => {
    if (isFile) {
      const files = items.map(item => item.file).reverse();
      console.log(files);
      this.editor.uploadImagesInFile(files);
    } else {
      const url = items.map(item => item.url).reverse()[0];
      this.editor.uploadImagesInUrl(url);
    }
    this.onImgModalCancel();
  };

  onImgModalCancel = () => {
    this.closeImgModal();
    this.editor.el.focus();
  };

  openFilmModal = () => {
    this.setState({
      filmModalVisible: true,
    });
  };

  onFilmModalCancel = () => {
    this.setState({
      filmModalVisible: false,
    });
    this.editor.el.focus();
  };

  // 在markdown编辑器当前光标处插入纯文本
  insertTextToEditor = (text) => {
    const { el } = this.editor;
    el.focus();
    let inserted = false;
    if (document.queryCommandSupported('insertText')) {
      inserted = document.execCommand('insertText', false, text);
    }
    if (!inserted) {
      const { selectionStart, selectionEnd, value } = el;
      el.value = value.slice(0, selectionStart) + text + value.slice(selectionEnd);
      el.selectionStart = selectionStart + text.length;
      el.selectionEnd = selectionStart + text.length;
      const event = document.createEvent('HTMLEvents');
      event.initEvent('input', false, false);
      el.dispatchEvent(event);
    }
  };

  // 先插入电影海报图片，再在图片后面跟上评分文字
  onFilmModalOk = (modalName, { film, score }) => {
    this.editor.uploadImagesInUrl(film.poster);
    this.insertTextToEditor(`\n${getFilmScoreText(score)}\n`);
    this.onFilmModalCancel();
  };

  onAudioModalCancel = () => {
    this.setState({
      audioModalVisible: false,
    });
    this.editor.el.focus();
  }

  openAudioModal = () => {
    const { isAudioExist } = this.state;
    const { userInfos } = this.props;
    const canUploadAudio = userInfos.getIn(['can_upload_audio']);
    const jsdLevel = userInfos.getIn(['jsd_level_for_upload_audio', 'min_score']);
    if (!canUploadAudio) {
      Modal.open(
        (
          <Fragment>
            <p className={styles['audio-explain-modal-content']}>
              {i18n.get('modal.insert-audio-explain', { minJSD: (jsdLevel / 1000).toFixed(0) })}
            </p>
            <div className={styles['audio-explain-modal-btn']}>
              <a className={styles['audio-explain-modal-btn-about']} href={'/mobile/fp/growth'} target='_blank'>{i18n.get('pay-note.about-jsd')}</a>
              <a className={styles['audio-explain-modal-btn-buy']} href={'/mobile/club'} target='_blank'>{i18n.get('pay-note.open-js-member')}</a>
            </div>
          </Fragment>
        ), {
          showFooter: false,
          title: i18n.get('modal.insert-audio-modal'),
          headerStyle: { textAlign: 'center' },
          tips: false,
          width: 360,
          top: '30%',
        },
      );
      return null;
    }
    this.setState({
      audioModalVisible: true,
      isAudioPlaying: false,
    }, () => {
      if (isAudioExist) {
        this.audio.pause();
      }
    });
    return null;
  }

  openGrammarModal = () => {
    this.setState({
      grammarModalVisible: true,
    });
  }

  onGrammarModalCancel = () => {
    this.setState({
      grammarModalVisible: false,
    });
  }

  onAudioPlay = () => {
    const { content } = this.props;
    const { match: { params: { noteId } } } = this.props;
    const playUrl = content.getIn(['entities', noteId.toString(), 'audio', 'play_url']);
    if (playUrl === '') {
      Modal.Confirm(`${i18n.get('modal.audio-transcoding')}`, {
        onOk: () => {
        },
        showCancelBtn: false,
      });
      return;
    }
    const changePlayType = () => {
      this.setState({
        isAudioPlaying: false,
      });
      this.audio.removeEventListener('ended', changePlayType);
    };
    this.setState({
      isAudioPlaying: !this.state.isAudioPlaying,
    }, () => {
      if (this.state.isAudioPlaying) {
        this.audio.addEventListener('ended', changePlayType);
        this.audio.play();
      } else {
        this.audio.removeEventListener('ended', changePlayType);
        this.audio.pause();
      }
    });
  }

  onModalConfirmBtnClick = (modalName, data = {}) => {
    const { title, dubber, noteId } = data;
    switch (modalName) {
      case 'audioModal':
        this.props.putAudioMessage(noteId, title, dubber);
        break;
      default:
        break;
    }
    this.onAudioModalCancel();
  }

  onToolItemClick = (action) => {
    const { history, match } = this.props;
    const { params: { nbId, noteId } } = match;
    switch (action) {
      case 'publicize-paid-note':
        this.publicizePaidNote(nbId, noteId);
        break;
      case 'compile-paid-note':
        this.publicizePaidNote(nbId, noteId, true);
        break;
      case 'openImageModal': {
        this.openImgModal();
        break;
      }
      case 'undo': {
        if (document.queryCommandSupported('undo')) {
          document.execCommand('undo');
        }
        break;
      }
      case 'redo': {
        if (document.queryCommandSupported('redo')) {
          document.execCommand('redo');
        }
        break;
      }
      case 'to-history': {
        history.push(`/notebooks/${nbId}/notes/${noteId}/history`);
        break;
      }
      case 'to-preview': {
        const { isPreviewMode } = this.props;
        if (isPreviewMode) {
          history.push(`/notebooks/${nbId}/notes/${noteId}`);
        } else {
          history.push(`/notebooks/${nbId}/notes/${noteId}/preview`);
        }
        break;
      }
      case 'to-fullscreen': {
        history.push(`/notebooks/${nbId}/notes/${noteId}/writing`);
        break;
      }
      case 'exit-fullscreen': {
        history.push(`/notebooks/${nbId}/notes/${noteId}`);
        break;
      }
      case 'auto-save': {
        this.saveNote({
          isForce: true,
        });
        break;
      }
      case 'privatize': {
        this.props.privateNote(noteId);
        break;
      }
      // 第一次发布
      case 'publicize': {
        this.publicizeNote(noteId);
        break;
      }
      // 发布更新
      case 'compile': {
        this.publicizeNote(noteId, true);
        break;
      }
      case 'openAudioModal':
        this.openAudioModal();
        break;
      case 'openGrammarModal':
        this.openGrammarModal();
        break;
      case 'openFilmModal':
        this.openFilmModal();
        break;
      default: {
        break;
      }
    }
  };
  initEditorWithTryCatch = (noteId) => {
    try {
      this.initEditor(noteId);
    } catch (error) {
      captureException(error, {
        noteId,
        hh: '文章初始化错误',
      });
    }
  }
  initEditor = (noteId) => {
    this.editor.destroy(); // 先销毁
    const { isWritingMode } = this.props;
    this.editor.init();
    this.setContent(noteId);
    this.updateAbbr();
    // 只有全屏模式需要自适应高度
    this.editor.setAutoResize(!!isWritingMode);
    this.editor.onEvent(Arthur.Events.DRAG_ENTER, this.dragEnter);
    this.editor.onEvent(Arthur.Events.DRAG_LEAVE, this.dragLeave);
    this.editor.onEvent(Arthur.Events.DROP, this.editorDrop);
    this.editor.onEvent(Arthur.Events.CONTENT_CHANGE, this.onContentChange);
    this.editor.onEvent(Arthur.Events.NOTIFY, this.notify);
    this.editor.onEvent(Arthur.Events.IMAGE_UPLOAD, this.uploadImage);
    this.editor.onEvent(Arthur.Events.EXTERNAL_IMAGE_UPLOAD, this.uploadExternalImage);
  };

  render() {
    const {
      imgModalVisible,
      filmModalVisible,
      audioModalVisible,
      isAudioExist,
      isAudioPlaying,
      grammarModalVisible,
    } = this.state;
    const {
      isPreviewMode,
      isWritingMode,
      wrapperClassName,
      content, match,
      userInfos,
    } = this.props;
    const { params: { noteId }, path } = match;
    const note = this.getNote();
    const wordNum = this.getNoteWordNum();
    const contentStatus = this.getContentStatus();

    const wrapperClass = classNames(wrapperClassName, {
      [styles['editor-wrapper']]: true,
      [styles['editor-wrapper-w-mode']]: !!isWritingMode,
      [styles['editor-wrapper-p-mode']]: !!isPreviewMode,
    });
    const toolCustomerClass = classNames({
      [styles['tool-bar__writing_mode']]: isWritingMode,
    });
    const audioPlay = classNames('fa fa-play-circle-o fa-2x', {
      [styles['hidden']]: isAudioPlaying,
    });
    const audioPause = classNames('fa fa-pause-circle-o fa-2x', {
      [styles['hidden']]: !isAudioPlaying,
    });

    return (
      <div className={wrapperClass} tabIndex={-1} onKeyDown={this.onKeyDown}>
        <EditorTitle isWritingMode={isWritingMode} onTitleChanged={this.onTitleChanged}/>
        <EditorToolBar
          isPaidNote={note.get('paid')}
          isNoteShared={note.get('shared')}
          isWritingMode={isWritingMode}
          isPreviewMode={isPreviewMode}
          onToolItemClick={this.onToolItemClick}
          contentChanged={this.contentIsDiff()}
          isPublishing={contentStatus === Notes.PUBLISH_NOTE}
          isAutoSaving={contentStatus === Notes.UPDATE_NOTE}
          customerClass={toolCustomerClass}
          isMarkDown
          wordNum={wordNum}
          isAudioExist={isAudioExist}
        />
        <TimePublishToolbar note={note}/>
        {
          isAudioExist &&
          <div className={styles['audio-container']}>
            <div className={styles['audio-player-content']}>
              <label className={styles['audio-player']} htmlFor="audio-player" onClick={this.onAudioPlay}>
                <i className={audioPlay}/>
                <i className={audioPause}/>
              </label>
              <audio
                id="audio-player"
                src={content.getIn(['entities', noteId.toString(), 'audio', 'play_url'])}
                className={styles['audio']}
                ref={(audio) => {
                  this.audio = audio;
                }}
              />
              <span className={styles['audio-message']}>
                <span className={styles['audio-title']}>
                  {content.getIn(['entities', noteId.toString(), 'audio', 'title'])}
                </span>
                <span className={styles['audio-dubber']}>
                  {content.getIn(['entities', noteId.toString(), 'audio', 'dubber'])}
                </span>
              </span>
              <span className={styles['audio-editor']} onClick={this.openAudioModal}>
                {i18n.get('modal.audio-edit')}
              </span>
            </div>
          </div>
        }
        <textarea
          id="arthur-editor"
          className={`${styles['editor']} source`}
          autoFocus
        />
        {
          imgModalVisible &&
          <EditorImgModal
            visible={imgModalVisible}
            onModalConfirmBtnClick={this.onImgModalOk}
            onModalCancelClick={this.onImgModalCancel}
          />
        }
        {
          filmModalVisible &&
          <EditorFilmModal
            visible={filmModalVisible}
            onModalConfirmBtnClick={this.onFilmModalOk}
            onModalCancelClick={this.onFilmModalCancel}
          />
        }
        {
          audioModalVisible &&
          <EditorAudioModal
            audioMessage={content.getIn(['entities', noteId.toString(), 'audio'])}
            visible={audioModalVisible}
            changeAudio={this.changeAudio}
            onModalCancelClick={this.onAudioModalCancel}
            onModalConfirmBtnClick={this.onModalConfirmBtnClick}
          />
        }
        <Modal
          visible={grammarModalVisible}
          title={i18n.get('grammar.grammar')}
          showFooter={false}
          maskClosable
          isMiddle
          width={320}
          tips={false}
          onCancel={this.onGrammarModalCancel}
        >
          <div className={styles['help-modal-body']}>
            <ul>
              <li>{i18n.get('grammar.h1')}</li>
              <li>{i18n.get('grammar.h2')}</li>
              <li>{i18n.get('grammar.h5')}</li>
            </ul>
            <ul>
              <li>{i18n.get('grammar.ul1')}</li>
              <li>{i18n.get('grammar.ul2')}</li>
            </ul>
            <ul>
              <li>{i18n.get('grammar.ol1')}</li>
              <li>{i18n.get('grammar.ol2')}</li>
            </ul>
            <ul>
              <li>{i18n.get('grammar.link')}</li>
              <li>{i18n.get('grammar.image')}</li>
            </ul>
            <ul>
              <li>{i18n.get('grammar.italic')}</li>
              <li>{i18n.get('grammar.bold')}</li>
              <li>{i18n.get('grammar.code-block')}</li>
              <li style={{ whiteSpace: 'pre' }}>{i18n.get('grammar.blockquote')}</li>
            </ul>
            <div className={styles['confirm-btn']} onClick={this.onGrammarModalCancel}>
              我知道了
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/MarkDownEditor.js